import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver loop error FIRST - this is a known harmless error
// that occurs with dynamic UI components like dropdowns and modals (Radix UI)
// This must be set up before anything else
const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
const resizeObserverErr = window.ResizeObserver;
if (resizeObserverErr) {
  window.ResizeObserver = class ResizeObserver extends resizeObserverErr {
    constructor(callback) {
      super((entries, observer) => {
        // Wrap in requestAnimationFrame to avoid loop errors
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

// Also suppress via error handlers
const suppressResizeObserverError = (e) => {
  if (e && e.message && e.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation?.();
    e.preventDefault?.();
    return true;
  }
  return false;
};

window.addEventListener('error', suppressResizeObserverError, true);
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason?.message?.includes('ResizeObserver loop')) {
    e.preventDefault();
  }
});

// Override console.error to suppress ResizeObserver errors from react-error-overlay
const originalConsoleError = console.error;
console.error = (...args) => {
  if (args[0] && typeof args[0] === 'string' && args[0].includes('ResizeObserver loop')) {
    return;
  }
  originalConsoleError.apply(console, args);
};

// Fix for "removeChild" error caused by browser extensions (Google Translate, AdBlock, etc.)
// that modify the DOM and conflict with React's virtual DOM
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function(child) {
    if (child.parentNode !== this) {
      if (console) {
        console.warn('Cannot remove a child from a different parent', child, this);
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (console) {
        console.warn('Cannot insert before a reference node from a different parent', referenceNode, this);
      }
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
